import React from "react";
import styled from "styled-components";

import { ResourceStrings } from "../../../ResourceStrings";
import Modal from "@fluentui/react/lib/Modal";
import { Icon } from "@fluentui/react/lib/Icon";
import { RootState } from "../../../store/rootState";
import { useSelector } from "react-redux";
import { IconButton } from "@fluentui/react/lib/Button";
import { forMinWidth } from "../../../theme/breakpoints";
import { PostId } from "../../../RootPost";
import { App } from "../../../app";
import { Link } from "react-router-dom";

interface Props {
    isOpen: boolean;
    onClose?: () => void;
}

const PostSubmittedDialog = (props: Props): JSX.Element => {
    const userName = useSelector((state: RootState) => state.appState.userName)
    const postUrl: string | null = useSelector((state: RootState) => state.appState.reportResultTicketUrl);

    return <Modal
        isOpen={props.isOpen}
        isBlocking={false}
        onDismiss={props.onClose}
    >
        <Container role="dialog" aria-label={ResourceStrings.thanksWhatsNext()}>
            <div className="title-bar">
                <IconButton
                    title="Close"
                    iconProps={{ iconName: 'Cancel' }}
                    onClick={props.onClose}
                />
            </div>
            <div className="content">
                <div className="text" aria-label={ResourceStrings.thanksReceivedFeedbackSendEmail(userName)}>{ResourceStrings.thanksReceivedFeedbackSendEmail(userName)}</div>
                <div className="text sub-heading" aria-label="View your new feedback">
                    <Link
                        to={postUrl}
                        onClick={(evt) => { evt.stopPropagation(); }}
                    >
                        View your new feedback
                    </Link>
                </div>
                <div className="text heading" aria-label={ResourceStrings.thanksWhatsNext()}>{ResourceStrings.thanksWhatsNext()}</div>

                {/* @TODO: Uncomment when we have a link ready for it */}
                {/* <div className="text sub-heading" aria-label={ResourceStrings.learnAboutFeedbackProcess()}>
                    <a href={feedbackProcess} target="_blank">{ResourceStrings.learnAboutFeedbackProcess()}</a>
                </div> */}

                <div className="icons">
                    <div>
                        <Icon iconName="ProfileSearch" />
                        <div className="text" aria-label={ResourceStrings.thanksWhatsNext_EngineerWillReview()}>{ResourceStrings.thanksWhatsNext_EngineerWillReview()}</div>
                    </div>
                    <div>
                        <Icon iconName="ServerProcesses" />
                        <div className="text" aria-label={ResourceStrings.thanksWhatsNext_PrioritizeActions()}>{ResourceStrings.thanksWhatsNext_PrioritizeActions()}</div>
                    </div>
                    <div>
                        <Icon iconName="CreateMailRule" />
                        <div className="text" aria-label={ResourceStrings.thanksWhatsNext_ReceiveEmail()}>{ResourceStrings.thanksWhatsNext_ReceiveEmail()}</div>
                    </div>
                </div>
            </div>
        </Container>
    </Modal>
}

export default PostSubmittedDialog;

const Container = styled.div`
    text-align: center;
    width: auto;
    max-width: 76rem;
    border: 0.1rem solid #3399ff;
    box-shadow: 0.2rem 0.2rem #000000 20% 0.1rem;

    .content {
        padding: 2rem 3rem 5rem;
    }

    ${forMinWidth.md`
        .content {
            padding: 2rem 9rem 5rem;
        }
    `}

    .title-bar {
        display: flex;
        justify-content: flex-end;
    }

    .icons {
        display: flex;
        justify-content: space-between;

        &>div + div {
            margin-left: 3.4rem;
        }

        i {
            font-size: 2.8rem;
            line-height: 6.4rem;
            color: var(--color-secondary);
            background-color: rgba(0,0,0, 0.04);
            width: 6rem;
            height: 6rem;
            line-height: 6rem;
            vertical-align: middle;
            border-radius: 50%;
            margin-bottom: 1.5rem;
        }
    }

    .text {
        line-height: 2.4rem;
    }

    .heading {
        font-size: 2.2rem;
        font-weight: 600;
        margin: 5.6rem 0;
    }

    .sub-heading {
        font-size: 1.6rem;
        margin-top: 2.6rem;
        a {
            color: var(--color-on-surface-link);
        }
    }
`;
